import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { RenderField, RenderSubmitButton } from '../../../common/form';
import * as Validations from '../../../common/form/commonValidations';
import './TableModal.less';
import { addNewTables } from '../../../../actions/SeatingChartActions';


const numSeatRange = (value) => {
  if (value > 99) {
    return 99;
  } else if (value < 0) {
    return 0;
  }
  return value;
};

const RenderNewTableFields = ({ newTable, fieldIndex, fields }) => (
  <div className="new-table-row">
    <div className="new-table-row">
      <Field
        name={`${newTable}.name`}
        component={RenderField}
        label="Name"
        type="text"
        className="new-table-num-seats"
        placeholder="Table Name"
        required
        validate={[Validations.REQUIRED, Validations.MAX_LENGTH_100]}
        maxChars={100}
        hideFormGroups
      />
      <Field
        name={`${newTable}.num_seats`}
        label="Number of Seats"
        component={RenderField}
        type="number"
        className="new-table-num-seats"
        required
        normalize={numSeatRange}
        validate={Validations.REQUIRED}
        hideFormGroups
      />
    </div>
    { fieldIndex !== 0 &&
      <div role="button" className="new-table-delete">
        <i className="zolaicon zolaicon-trashcan" onClick={() => fields.remove(fieldIndex)} />
      </div>
    }
  </div>
);

RenderNewTableFields.propTypes = {
  newTable: PropTypes.string,
  fieldIndex: PropTypes.number,
  fields: PropTypes.shape({})
};

class NewTableFields extends Component {

  componentWillMount() {
    const { fields } = this.props;
    fields.push({ name: '' });
  }

  render() {
    const { fields, id, label, hideFormGroup } = this.props;
    return (
      <div className={`${hideFormGroup ? '' : 'form-group'}}`} style={{ position: 'relative' }}>
        <label htmlFor={id}>{label}</label>
        <div id={id} className="new-table-list">
          {fields.map((newTable, index, fieldsRef) => (
            <RenderNewTableFields
              key={index}
              newTable={newTable}
              fieldIndex={index}
              fields={fieldsRef}
            />
          ))}
        </div>
        <span role="button" className="text-primary add-additional-table-option" onClick={() => fields.push({ name: '' })}>+ Add another table</span>
      </div>
    );
  }
}

NewTableFields.propTypes = {
  fields: PropTypes.shape({}),
  id: PropTypes.string,
  label: PropTypes.string,
  hideFormGroup: PropTypes.bool
};

const NewTableModal = ({ handleSubmit, pristine, submitting, valid }) => (
  <div>
    <div className="modal-header">
      <h3 className="modal-title">Add Table</h3>
    </div>
    <form onSubmit={handleSubmit} id="table-form" className="tableModal__form" noValidate>
      <FieldArray
        name="new_tables"
        component={NewTableFields}
        id="new-table-fields"
        lockAxis="y"
      />
      <div className="tableModal__form--add">
        <RenderSubmitButton pristine={pristine} submitting={submitting} valid={valid} />
      </div>
    </form>
  </div>
);

NewTableModal.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  valid: PropTypes.bool.isRequired
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onSubmit: createTaskRequest => dispatch(addNewTables(createTaskRequest)).then(() => {
      ownProps.hideModalFn();
    })
  }
);

export default connect(
  null,
  mapDispatchToProps
)(reduxForm({
  form: 'table_form'
})(NewTableModal));



/** WEBPACK FOOTER **
 ** ./src/components/manage/seatingchart/seatingChartModals/NewTableModal.jsx
 **/